import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";

const SkeletonDataAnalysis = () => {
  return (
    <div className="w-full">
      <div className="flex flex-col sm:flex-row items-center aiso-data-card aiso-shadow mb-3">
        <div className="w-full sm:w-2/12 cursor-pointer">
          <div className="img-cover-box  h-48">
            <Skeleton animation="wave" variant="rect" height={200} width="100%" />
          </div>
        </div>
        <div className="w-full sm:w-10/12 py-3">
          <div className="w-full flex justify-between items-center px-3">
            <div className="w-5/6 px-3 cursor-pointer">
              <Skeleton animation="wave" height={20} width={80} />
              <div className="truncate-1-lines font-gmarket-medium text-888 mt-2">
                <Skeleton animation="wave" height={15} width="80%" style={{ marginBottom: 6 }} />
              </div>
            </div>
            <div className="z-50 px-3">
              <Skeleton animation="wave" variant="rect" height={40} width={40} />
            </div>
          </div>
          <div className="w-full flex justify-between items-end px-3 mt-8">
            <div className="w-full flex justify-between">
              <div className="flex justify-start items-center px-3  cursor-pointer">
                <div>
                  <div className="img-cover-box w-10 h-10 rounded-full border">
                    <Skeleton animation="wave" variant="circle" width={40} height={40} />
                  </div>
                </div>
                <div className="ml-2">
                  <Skeleton animation="wave" height={20} width={80} />
                  <Skeleton animation="wave" height={20} width={100} />{" "}
                </div>
              </div>
              <p className="text-xs text-333 font-gmarket-medium">
                <Skeleton animation="wave" height={10} width="20%" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonDataAnalysis;
